import React from "react";
import { object, string } from "prop-types";

// components
import RegularFunnel from "./Funnels/RegularFunnel";
import RegularFunnelWithLinks from "./Funnels/RegularFunnelWithLinks";
import RegularFunnelWithClicks from "./Funnels/RegularFunnelWithClicks";
import CTADistributionFunnel from "./Funnels/CTADistributionFunnel";
import CTADistributionFunnelWithClicks from "./Funnels/CTADistributionFunnelWithClicks";
import SimpleNavFunnel from "./Funnels/SimpleNavFunnel";
import LastNavFunnel from "./Funnels/LastNavFunnel";
import NewRegularFunnelContainer from "./Funnels/NewRegularFunnelContainer";
import RegularFunnelWithUnderstanding from "./Funnels/RegularFunnelWithUnderstanding";

const FunnelChartLoader = props => {
  let { funnelType } = props;
  let customFunnel;
  if (funnelType === "regular") {
    customFunnel = <RegularFunnel {...props} />;
  } else if (funnelType === "cta-distribution") {
    customFunnel = <CTADistributionFunnel {...props} />;
  } else if (funnelType === "cta-distribution-with-clicks") {
    customFunnel = <CTADistributionFunnelWithClicks {...props} />;
  } else if (funnelType === "simple-nav") {
    customFunnel = <SimpleNavFunnel {...props} />;
  } else if (funnelType === "last-nav-funnel") {
    customFunnel = <LastNavFunnel {...props} />;
  } else if (funnelType === "regular-with-links") {
    customFunnel = <RegularFunnelWithLinks {...props} />;
  } else if (funnelType === "regular-with-clicks") {
    customFunnel = <RegularFunnelWithClicks {...props} />;
  } else if (funnelType === "regular-with-clicks-in-bars") {
    customFunnel = <NewRegularFunnelContainer {...props} />;
  } else if (funnelType === "regular-with-understanding") {
    customFunnel = <RegularFunnelWithUnderstanding {...props} />;
  } else {
    customFunnel = <RegularFunnel {...props} />;
  }
  return customFunnel;
};

FunnelChartLoader.propTypes = {
  timeframe: object,
  campaign: object,
  actor: string,
  video: object
};

export default FunnelChartLoader;



// WEBPACK FOOTER //
// ./src/components/charts/FunnelChartLoader.js